var exports = {
  "jl": "TabNav__qHkBGx",
  "Zs": "TabNavList__wLlQxB",
  "TV": "TabNavLink__LGP-9p",
  "wH": "selected__NLIm71",
};

module.exports = exports;
